module.exports = __webpack_public_path__ + "img/pc_self_new.1c325f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/FooterAd/image/pc_self_new.jpg
// module id = zB+f
// module chunks = 0